import { SearchMode } from 'services/SwaggerApi';

export const search_mode: SearchMode[] = [
    'CorporateAndFast',
    'NoncorporateAndFast',
];
